import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../../api";

export const useUpdateAssignmentPreferences = ({ assignment }) => {
  const [saving, setSaving] = useState(false);
  const ApiClient = useApiClient();

  const updatePreferences = async ({ prefs, onSuccess }) => {
    if (!assignment?.id) return false;

    setSaving(true);
    try {
      const response = await ApiClient.assignment.updateAssignmentPreferences({
        assignment: assignment?.id,
        prefs: prefs,
      });

      if (response.success) {
        enqueueSnackbar("Preferences updated", {
          variant: "success",
          autoHideDuration: 3000,
        });

        if (onSuccess) onSuccess(prefs);
        return true;
      } else {
        enqueueSnackbar("There was a problem saving your preferences", {
          variant: "error",
          autoHideDuration: 3000,
        });
        return false;
      }
    } catch (err) {
      enqueueSnackbar("There was a problem saving your preferences", {
        variant: "error",
        autoHideDuration: 3000,
      });
      return false;
    } finally {
      setSaving(false);
    }
  };

  return {
    updatePreferences,
    saving,
  };
};
